export const SystemObjectTypeVals = {
  Folder: 1,
  ProjectDoc: 2
}